export const TOO_SHORT = "Příliš krátké!";
export const TOO_LONG = "Příliš dlouhé!";
export const TOO_LOW = "Příliš malé!";
export const TOO_LARGE = "Příliš velké!";
export const REQUIRED = "Povinná informace!";
